(function favoritesControllerDefinition() {
    'use strict';

    angular.module('Favorites')
        .controller('FavoritesController', [
            '$scope', '$state', '$translate', 'errorsExtend', 'authExtend', 'alerts', 'recentElementsService', 'storageService', 'documentService', 'documentTypeService', 'fileService', 'fileDownloader', 'documentContainerService', 'containerTypeService', 'documentContainersShortcutsService', 'favoritesService', 'documentContainerAction', 'documentAction', 'documentContainerAction',
            function favoritesController($scope, $state, $translate, errors, authExtend, alerts, recentElementsService, storageService, documentService, documentTypeService, fileService, fileDownloader, documentContainerService, containerTypeService, documentContainersShortcutsService, favoritesService, documentContainerAction, documentAction) {

                $scope.load = function () {
                    $scope.documentRead = authExtend.isInRole('DOCUMENT READ');
                    $scope.documentContainerRead = authExtend.isInRole('DOCUMENTCONTAINER READ');
                    $scope.isImpersonated = authExtend.getOrganizationId() !== '';

                    $scope.recentGrid = { documents: [] };
                    $scope.recentsSortedBy = { asc: true, header: 'LastDateAccess', headerIndex: 1 };
                    $scope.recentData = { totalItems: 0, hasItems: function (list) { return $scope.recentData.totalItems > 0; } };

                    $scope.favoritesGrid = { documents: [], valuesCount: 0 };
                    $scope.favoritesSortedBy = { asc: true, header: 'name', headerIndex: 1 };
                    $scope.favoritesData = { totalItems: 0, maxPage: 0, currentPage: 1, itemsPerPage: 10, hasItems: function (list) { return $scope.favoritesData.totalItems > 0; } };

                    $scope.aux = {
                        activeGrids: 0,
                        activeGrid: 'Recents'
                    };

                    $scope.searchRecent();
                    $scope.updateActiveGrids();
                };

                //       *******  ELEMENTOS RECIENTES  *********       //

                $scope.loadRecentActions = function () {
                    // guardo la data en cada registro por que cada documento o carpeta puede ser de distinto type

                    return $scope.recentGrid.documents.forEach(function (docu) {
                        if (docu.type === 'DOCUMENTS') {
                            documentTypeService.isDoctypeInRole(['FILE DOWNLOAD'], docu.classId).then(function (r) { docu.downloadBtn = r; });
                            documentTypeService.isDoctypeInRole(['FILE READ'], docu.classId).then(function (r) { docu.viewPDFBtn = r; });
                            documentTypeService.isDoctypeInRole(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE'], docu.classId).then(function (r) { docu.canCheckOut = r; });
                            docu.IsCheckedOutByMe = authExtend.getUserId() === docu.documentCheckedOutById.toString();
                            docu.IsCheckedOutByOther = docu.documentCheckedOutById > 0 && !docu.IsCheckedOutByMe;
                        }
                        else {
                            containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER WRITE'], docu.classId).then(function (r) { docu.canCheckOut = r; });
                            containerTypeService.isContainertypeInRole(['FILE READ'], docu.classId).then(function (r) { docu.viewPDFBtn = r; });
                            containerTypeService.isContainertypeInRole(['FILE DOWNLOAD'], docu.classId).then(function (r) { docu.downloadAllBtn = r; });
                            docu.IsCheckedOutByMe = authExtend.getUserId() === docu.documentCheckedOutById.toString();
                            docu.IsCheckedOutByOther = docu.documentCheckedOutById > 0 && !docu.IsCheckedOutByMe;
                        }
                    });
                };

                $scope.sortRecentsColumn = function (header) {                    
                    $scope.recentsSortedBy.header = header;
                    $scope.recentsSortedBy.asc = !$scope.recentsSortedBy.asc;
                };

                $scope.searchRecent = function () {
                    if (($scope.documentRead || $scope.documentContainerRead) && $scope.isImpersonated) {
                        $scope.recentGrid.documents = [];

                        var type = $scope.documentRead && $scope.documentContainerRead ? '' : ($scope.documentRead ? 'DOCUMENTS' : 'CONTAINERS');
                        return recentElementsService.getRecentElements(type).then(function getOk(result) {
                            $scope.recentGrid.documents = result;                           
                            $scope.searched = $scope.recentGrid.documents.length > 0;
                            $scope.recentData.totalItems = $scope.recentGrid.documents.length;
                            $scope.loadRecentActions();
                            $scope.updateActiveGrids();
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.addFavorite = function (docu) {
                    return favoritesService.addFavorite(docu.id, docu.type).then(function getOk(result) {
                        docu.favorited = true;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.checkInDocument = function (document) {                    
                    if (document.type === 'DOCUMENTS') {
                        return documentAction.checkIn(document, document.classId).then(function (doc) {
                            document.IsCheckedOutByMe = false;
                        });
                    } else {
                        return documentContainerAction.checkIn(document).then(function (doc) {
                            document.IsCheckedOutByMe = false;
                        });
                    }
                };

                $scope.goToModifyDoc = function (document) {
                    if (document.type === 'DOCUMENTS') {
                        $state.go('document-modify', { id: document.id });
                    } else {
                        $state.go('document-container-modify', { id: document.id });
                    }
                };

                //       *******  ELEMENTOS FAVORITOS  *********       //
                $scope.loadFavoritesActions = function () {
                    // guardo la data en cada registro por que cada documento puede ser de distinto type
                    return $scope.favoritesGrid.documents.forEach(function (docu) {
                        if (docu.type === 'DOCUMENTS') {
                            documentTypeService.isDoctypeInRole(['FILE DOWNLOAD'], docu.classId).then(function (r) { docu.downloadBtn = r; });
                            documentTypeService.isDoctypeInRole(['FILE READ'], docu.classId).then(function (r) { docu.viewPDFBtn = r; });
                            documentTypeService.isDoctypeInRole(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE'], docu.classId).then(function (r) { docu.canCheckOut = r; });
                            documentTypeService.isDoctypeInRole(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE'], docu.classId).then(function (r) { docu.canCheckOut = r; });
                            docu.IsCheckedOutByMe = authExtend.getUserId() === docu.documentCheckedOutById.toString();
                            docu.IsCheckedOutByOther = docu.documentCheckedOutById > 0 && !docu.IsCheckedOutByMe;
                        }
                        else {
                            containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER WRITE'], docu.classId).then(function (r) { docu.canCheckOut = r; });
                            containerTypeService.isContainertypeInRole(['FILE READ'], docu.classId).then(function (r) { docu.viewPDFBtn = r; });
                            containerTypeService.isContainertypeInRole(['FILE DOWNLOAD'], docu.classId).then(function (r) { docu.downloadAllBtn = r; });
                            docu.IsCheckedOutByMe = authExtend.getUserId() === docu.documentCheckedOutById.toString();
                            docu.IsCheckedOutByOther = docu.documentCheckedOutById > 0 && !docu.IsCheckedOutByMe;
                        }
                    });
                };

                $scope.searchFavorites = function () {

                    if (($scope.documentRead || $scope.documentContainerRead) && $scope.isImpersonated) {
                        $scope.favoritesGrid.documents = [];

                        return favoritesService.getFavorites(null, $scope.favoritesData.currentPage, $scope.favoritesData.itemsPerPage, $scope.favoritesSortedBy.headerIndex, $scope.favoritesSortedBy.asc).then(function getOk(result) {
                            $scope.favoritesGrid = result;
                            $scope.favoritesData.totalItems = result.valuesCount;
                            $scope.favoritesData.maxPage = Math.ceil($scope.favoritesData.totalItems / $scope.favoritesData.itemsPerPage);
                            $scope.loadFavoritesActions();
                            $scope.updateActiveGrids();
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.sortFavoritesColumn = function (header) {
                    $scope.favoritesSortedBy.header = header;
                    $scope.favoritesSortedBy.headerIndex = header === 'id' ? 0 : header === 'name' ? 1 : header === 'lastModifiedDate' ? 2: 3;
                    $scope.favoritesSortedBy.asc = !$scope.favoritesSortedBy.asc;
                    $scope.searchFavorites();
                };

                $scope.favoritesPreviousPage = function () {
                    if ($scope.favoritesData.currentPage > 1) {
                        $scope.favoritesData.currentPage -= 1;
                        $scope.searchFavorites();
                    }
                };

                $scope.favoritesNextPage = function () {
                    var maxPage = Math.ceil($scope.favoritesData.totalItems / $scope.favoritesData.itemsPerPage);

                    if ($scope.favoritesData.currentPage < maxPage) {
                        $scope.favoritesData.currentPage += 1;
                        $scope.searchFavorites();
                    }
                };

                $scope.removeFavorite = function (fav) {
                    return favoritesService.removeFavorite(fav.id, fav.type).then(function getOk(result) {
                        $scope.searchFavorites();
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };


                $scope.goToElementDetail = function (docu) {
                    storageService.setStateBackFind('');
                    if (docu.type === 'DOCUMENTS') {
                        $state.go('document-detail', { id: docu.id });
                    }
                    else {
                        $state.go('document-container-detail', { id: docu.id })
                    }
                };

                $scope.checkOutElement = function (document) {
                    if (document.type === 'DOCUMENTS') {
                        return documentService.checkout(document).then(function () {
                            errors.showSuccess('DocumentCheckOutSucces');
                            document.IsCheckedOutByMe = true;
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                    else {
                        return $translate(['Warning', 'DocumentContainerCheckOutConfirmText', 'Yes', 'No'])
                            .then(function (translated) {
                                return alerts.confirm(translated.Warning, translated.DocumentContainerCheckOutConfirmText, translated.Yes, translated.No)
                                    .then(function getOk(result) {
                                        if (!result) {
                                            return result;
                                        }
                                        return documentContainerService.checkout(document)
                                            .then(function getOk(result) {
                                                errors.showSuccess('DocumentContainerCheckOutSucces');
                                                document.IsCheckedOutByMe = true;
                                                $scope.searchRecent();
                                            }, function (error) {
                                                errors.showError(error);
                                            });
                                    });
                            });
                    }
                };

                $scope.goToElementView = function (element) {
                    if (element.type === 'DOCUMENTS') {
                        storageService.setStateBackFind('');
                        $state.go('file-document-detail', { id: element.id, version: element.nroVersion });
                    }
                    else {
                        storageService.setStateBackFind('');
                        $state.go('file-document-container-detail', { id: element.id });
                    }
                };

                $scope.downloadElement = function (document) {
                    return fileService.downloadFilesDocument(document.id).then(function (result) {

                        var success = fileDownloader.saveAs(result.value, document.name + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.toggleAccordions = function (grid) {
                    $scope.aux.activeGrid = $scope.aux.activeGrid === grid ? '' : grid;

                    if ($scope.aux.activeGrid === 'Favorites' && !$scope.favoritesData.hasItems()) {
                        $scope.searchFavorites();
                    }
                };

                $scope.updateActiveGrids = function () {
                    $scope.aux.activeGrids = 1 + ($scope.recentData.hasItems() ? 1 : 0);
                    
                   
                };

                $scope.downloadContainer = function (docu) {
                    return documentContainerAction.downloadFilesContainer(docu);
                };

                $scope.load();
            }]);
})();